export default "__VITE_ASSET__BEI8teOi__"